/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SlotLabel/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function SlotLabel({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/SlotLabel",
  hours,
  minutes,
  range
  
}) {
  let isMedia = useIsMedia()
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="SlotLabel.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-1-Z1U9euk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="SlotLabel.Horizontal:1"
  data-view-path={viewPath}
 style={{'--s-2-Z1U9euk': isMedia.mobile ? 0.8 : 1}}
 className={`views-block ${styles.Horizontal1}`}
>
<fromFlow.When is={hours}>
<div
  data-testid="SlotLabel.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={22}
 weight="semibold"
 color={dtColorsNeutral400}
 text={hours}
/>
<div
  data-testid="SlotLabel.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={10}
 lineHeight="12px"
 weight="semibold"
 color={dtColorsNeutral400}
 text={minutes}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 lineHeight="10px"
 fontSize={8}
 weight="semibold"
 color={dtColorsNeutral300}
 text={range}
/>
</div>
</div>
</fromFlow.When>
<fromFlow.When is={!hours}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={12}
 weight="regular"
 color={dtColorsNeutral400}
 text={minutes}
/>
</fromFlow.When>
</div>
</div>
{children}
</React.Fragment>)
}